import React from 'react'

import { Border, Wrapper } from 'Components/UI'

import { BLOG_PAGE } from 'Constants/Paths'

import { BlogRecordFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import Post from './post'
import { Container, Content, PageButton, PageInfo, Pagination } from './styles'

type Props = {
  data?: BlogRecordFragment[]
  page?: number
  totalPages?: number
}

function Posts({ data, page = 1, totalPages = 1 }: Props) {
  if (!data?.length) return null

  return (
    <>
      <Container>
        <Wrapper>
          <Content>
            {data.map(entity => (
              <Post data={entity} key={entity?.id} />
            ))}
          </Content>
        </Wrapper>

        {totalPages > 1 && (
          <Pagination>
            {page > 1 && (
              <PageButton href={BLOG_PAGE(page - 1)}>Newer posts</PageButton>
            )}

            <PageInfo>
              Page {page} of {totalPages}
            </PageInfo>

            {page < totalPages && (
              <PageButton href={BLOG_PAGE(page + 1)}>Older posts</PageButton>
            )}
          </Pagination>
        )}
      </Container>

      <Border bottomLeft secondary />

      <Border bg="secondary" topRight />
    </>
  )
}

export default Posts
